<main id="main-content" tabindex="-1">
<mat-card>
    <mat-card-header>
        <mat-card-title-group>
          <mat-card-title>
            <h1>Invoice(s) Selected for Payment</h1>
          </mat-card-title>
        </mat-card-title-group>
    </mat-card-header>
    <mat-card-content>
        <div class="fee-worksheet-reminder" *ngIf="receivableTypeCode === 'RTKAO' || receivableTypeCode === 'RTKOG'">
            <em>You must update amount due to that calculated on the fee worksheet. Click on the <span class="fee-worksheet-reminder-blue"><b>"Actions"</b></span> column and then click on the<b>"Edit Amount Due"</b> option to update amount.</em>
        </div>
        <table mat-table matSort [dataSource]="dataSource">
            <!-- [tableStyle]="{ 'min-width': '50rem' }"> -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Receivable ID</th>
                <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                <td mat-footer-cell *matFooterCellDef> Total </td>
            </ng-container>
            
            <ng-container matColumnDef="typeDesc">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Fee Description</th>
                <td mat-cell *matCellDef="let element">{{ element.typeDesc }}</td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            
            <ng-container matColumnDef="paymentOwner">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Owner</th>
                <td mat-cell *matCellDef="let element">{{ element.paymentOwner }}</td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            
            <ng-container matColumnDef="balanceDue">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount Due</th>
                <td mat-cell *matCellDef="let element">{{ element.balanceDue | currency  }}</td>
                <td mat-footer-cell *matFooterCellDef> {{getTotalAmountDue() | currency}} </td>
            </ng-container>
            
            <ng-container matColumnDef="dueDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Due Date</th>
                <td mat-cell *matCellDef="let element">{{ element.dueDate }}</td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
                <td mat-cell *matCellDef="let element; let r = index">
                    <button mat-button [id]="'table_ActionMenu_'+r" [matMenuTriggerFor]="menu" aria-label="Actions">Actions</button>
                    <mat-menu #menu="matMenu">
                        <ng-container *ngFor="let action of getActionsForItem(element); let i = index">
                            <button mat-menu-item [id]="'table_ActionLink_'+i" (click)="onActionClicked(element, action)" [attr.aria-label]="action.title"><i ngClass="{{action.className || ''}}">{{action.icon}}</i>{{action.title}}</button>
                        </ng-container>
                    </mat-menu>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>

                <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
            </tr>
        </table>
        <mat-form-field>
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
        </mat-form-field>
        <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page"></mat-paginator>
        
        <!-- <div class="flex justify-content-end">
            <h4>Total Amount Due: {{totalBalanceDue|currency}}</h4>
        </div> -->
    </mat-card-content>
    <mat-dialog-actions align="center">
        <button mat-flat-button id="add_btn" (click)="addAnother()" [attr.aria-label]="'Click here for additional ' + receivableType + ' invoice to Pay Online'">Click here for additional {{receivableType}} invoice to Pay Online</button>
        <br/>
        <div>
            <em>If you are paying after the due date, a late fee may be included in the amount due</em>
        </div>
    </mat-dialog-actions>
    <mat-dialog-actions align="end">
                <button mat-flat-button id="pay_btn" (click)="pay()" aria-label="Pay" [disabled]="isPaying">
                    <mat-progress-spinner *ngIf="isPaying" diameter="20" mode="indeterminate" class="progress-spinner"></mat-progress-spinner>
                    Pay
                </button>
        <button mat-flat-button id="startOver_btn" (click)="startOver()" aria-label="Start Over">Start Over</button>
    </mat-dialog-actions>
</mat-card>
</main>